import { render, staticRenderFns } from "./ImageCardTr.vue?vue&type=template&id=40fbfd7c&"
import script from "./ImageCardTr.vue?vue&type=script&lang=js&"
export * from "./ImageCardTr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports